export const getGa4ClientId = (measurementId: string): Promise<string | undefined> => {
  const timeoutPromise: Promise<undefined> = new Promise((resolve) => {
    const wait = setTimeout(() => {
      clearTimeout(wait);
      resolve(undefined);
    }, 1500);
  });

  const clientIdPromise: Promise<string | undefined> = new Promise((res) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).gtag?.('get', measurementId, 'client_id', (clientId: string | undefined) => {
      res(clientId);
    });
  });

  return Promise.race([timeoutPromise, clientIdPromise]);
};
